import { pslClient } from "@/common/http-common";
import { API_URL_APPLY, API_URL_POST_SDN } from "@/constants/api.constants.js";
import { getPostUrlByQuoteAccess } from "@/common/utils";

class ApplicationService {
  apply(quoteId, data, config) {
    const url = getPostUrlByQuoteAccess(`${API_URL_APPLY}/${quoteId}`, config);
    return pslClient.post(url, data, config).then((res) => {
      return res.data;
    });
  }
  saveSDNs(quoteRequestId, data, config) {
    // Build the SDN on the server
    const url = `${API_URL_POST_SDN}/${quoteRequestId}`;
    return pslClient.post(url, data, config).then((res) => {
      return res.data;
    });
  }
}

export default new ApplicationService();
